import { useEffect, useMemo, useState } from "react";
import { BookOpen, ChevronRight, X } from "lucide-react";
import { api } from "../lib/api";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [activeCat, setActiveCat] = useState("All");

  useEffect(() => {
    api.get("/resources").then((r) => setItems(r.data.resources || []));
  }, []);

  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = activeCat === "All" ? items : items.filter((i) => i.category === activeCat);

  return (
    <div className="max-w-6xl mx-auto" data-testid="resources-page">
      <span className="eyebrow">Member resource library</span>
      <h1 className="font-display text-4xl md:text-5xl text-[#1A1F3D] mt-3">Resources</h1>
      <p className="text-[#52525b] mt-3 text-lg max-w-2xl">Troubleshooting, cleanup, platform guidance, file organisation. Read once, reference forever.</p>

      <div className="mt-8 flex gap-2 flex-wrap">
        {cats.map((c) => (
          <button
            key={c}
            onClick={() => setActiveCat(c)}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${activeCat === c ? "bg-[#1A1F3D] text-white" : "bg-white border border-[#e5e7eb] text-[#52525b] hover:border-[#D4A853]"}`}
            data-testid={`res-cat-${c}`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((r) => (
          <button
            key={r.id}
            onClick={() => setActive(r)}
            className="text-left bsp-card bsp-card-hover p-6"
            data-testid={`res-${r.id}`}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#F5E6E0] flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-[#1A1F3D]" strokeWidth={1.6} />
              </div>
              <span className="text-xs uppercase tracking-wider font-semibold text-[#D4A853]">{r.category}</span>
            </div>
            <h3 className="font-display text-xl text-[#1A1F3D] mt-4">{r.title}</h3>
            <p className="mt-2 text-sm text-[#52525b]">{r.description}</p>
            <div className="mt-4 inline-flex items-center text-sm text-[#1A1F3D] font-medium">Read <ChevronRight className="w-4 h-4 ml-1" /></div>
          </button>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 z-40 bg-black/40 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="resource-modal">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto p-8 relative scrollbar-clean" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute top-4 right-4 text-[#52525b] hover:text-[#1A1F3D]" data-testid="close-resource">
              <X className="w-5 h-5" />
            </button>
            <span className="text-xs uppercase tracking-wider font-semibold text-[#D4A853]">{active.category}</span>
            <h2 className="font-display text-3xl text-[#1A1F3D] mt-2">{active.title}</h2>
            <p className="text-[#52525b] mt-2">{active.description}</p>
            <div className="mt-6 prose prose-sm max-w-none text-[#2D2D2D] whitespace-pre-line leading-relaxed">{active.content}</div>
          </div>
        </div>
      )}
    </div>
  );
}
